var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 72.729,
    height: 77.577,
    viewBox: "0 0 72.729 77.577",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Icon_awesome-dice-d20"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.502,
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-dice-d20-2",
    "data-name": "Icon awesome-dice-d20",
    d: "M16.174,32.585.182,56.205a1.211,1.211,0,0,0,.9,1.839l31.555,3.344ZM1.123,47.793,12.53,29.255.918,22.288a.606.606,0,0,0-.918.52V47.476A.606.606,0,0,0,1.123,47.793Zm1.642,16.39L32.22,77.464a1.212,1.212,0,0,0,1.72-1.1v-9.95L3.1,63.035a.606.606,0,0,0-.333,1.147ZM15.071,25.124,27.182,3.467a1.212,1.212,0,0,0-1.633-1.688L2.7,16.72a.607.607,0,0,0,.02,1.027l12.353,7.377Zm21.293,1.542H52.911L38.429,1.155a2.424,2.424,0,0,0-4.13,0L19.817,26.667ZM71.81,22.288,60.2,29.256,71.605,47.794a.606.606,0,0,0,1.123-.318V22.808A.606.606,0,0,0,71.81,22.288ZM57.657,25.124,70.01,17.746a.606.606,0,0,0,.02-1.027L47.179,1.779a1.212,1.212,0,0,0-1.633,1.688ZM69.629,63.035,38.788,66.413v9.95a1.211,1.211,0,0,0,1.72,1.1L69.963,64.181A.605.605,0,0,0,69.629,63.035ZM56.554,32.585l-16.459,28.8,31.555-3.344a1.212,1.212,0,0,0,.9-1.839L56.553,32.585Zm-20.19-1.07H21.147L36.364,58.144,51.581,31.515Z",
    fill: "#006151"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Icon_awesome-dice-d20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-dice-d20-3",
    "data-name": "Icon awesome-dice-d20",
    d: "M16.174,32.585.182,56.205a1.211,1.211,0,0,0,.9,1.839l31.555,3.344ZM1.123,47.793,12.53,29.255.918,22.288a.606.606,0,0,0-.918.52V47.476A.606.606,0,0,0,1.123,47.793Zm1.642,16.39L32.22,77.464a1.212,1.212,0,0,0,1.72-1.1v-9.95L3.1,63.035a.606.606,0,0,0-.333,1.147ZM15.071,25.124,27.182,3.467a1.212,1.212,0,0,0-1.633-1.688L2.7,16.72a.607.607,0,0,0,.02,1.027l12.353,7.377Zm21.293,1.542H52.911L38.429,1.155a2.424,2.424,0,0,0-4.13,0L19.817,26.667ZM71.81,22.288,60.2,29.256,71.605,47.794a.606.606,0,0,0,1.123-.318V22.808A.606.606,0,0,0,71.81,22.288ZM57.657,25.124,70.01,17.746a.606.606,0,0,0,.02-1.027L47.179,1.779a1.212,1.212,0,0,0-1.633,1.688ZM69.629,63.035,38.788,66.413v9.95a1.211,1.211,0,0,0,1.72,1.1L69.963,64.181A.605.605,0,0,0,69.629,63.035ZM56.554,32.585l-16.459,28.8,31.555-3.344a1.212,1.212,0,0,0,.9-1.839L56.553,32.585Zm-20.19-1.07H21.147L36.364,58.144,51.581,31.515Z",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDice);
export default __webpack_public_path__ + "static/media/dice.9c7daeeac7532178c26ed14bc2e9376f.svg";
export { ForwardRef as ReactComponent };